import type { LlmChatSlashCommandDto } from '@paladin-monorepo/common';

/**
 * Text typed after a leading `/`, or null when no command is being typed.
 *
 * A command must start the message, and the picker closes at the first whitespace, so it
 * never opens over the free text that follows a chosen command.
 */
export function findSlashCommandQuery(value: string, caret: number): string | null {
  const match = /^\/([a-z0-9-]*)$/i.exec(value.slice(0, caret));
  return match ? match[1].toLowerCase() : null;
}

/** Names that start with the query first, then names that only contain it. */
export function filterSlashCommands(
  commands: LlmChatSlashCommandDto[],
  query: string,
): LlmChatSlashCommandDto[] {
  const starts = commands.filter((c) => c.name.startsWith(query));
  const contains = commands.filter((c) => !c.name.startsWith(query) && c.name.includes(query));
  return [...starts, ...contains];
}

/** Replaces the leading `/query` run with the full command and a space. */
export function insertSlashCommand(
  value: string,
  name: string,
): { value: string; caret: number } {
  const rest = value.replace(/^\/[a-z0-9-]*/i, '').replace(/^\s+/, '');
  const head = `/${name} `;
  return { value: head + rest, caret: head.length };
}
